export enum WaybillStatus {
  Created = 7,
  Pending_Delivery = 8,
  Delivered = 9,
  Invoiced = 10,
  Cancelled = 11,
}
